import { ManufacturingLocationChip } from "@/lib/manufacturingLocationChip";
import { cn } from "@/lib/utils";
import type { InventoryBox } from "@/lib/inventoryBoxApi";

const PLACEMENT_CHIP_CLASS =
  "inline-flex shrink-0 items-center rounded-md border border-slate-300 bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-800";

const SUBLOCATION_UNSET_CHIP_CLASS =
  "inline-flex shrink-0 items-center rounded-md border border-dashed border-slate-300 bg-white px-2 py-0.5 text-xs font-medium text-slate-500";

export function inventoryBoxStationPlacementLabel(box: InventoryBox): string {
  const station = box.floor_station_name?.trim() ?? "";
  return station !== "" ? station : "Warehouse";
}

export function inventoryBoxSublocationPlacementLabel(box: InventoryBox): string {
  if (box.sublocation.trim() !== "") {
    return box.sublocation_label.trim();
  }
  return "Not set";
}

export function InventoryBoxCurrentLocationBadges({ box }: { box: InventoryBox }): JSX.Element {
  const stationLabel = inventoryBoxStationPlacementLabel(box);
  const sublocationLabel = inventoryBoxSublocationPlacementLabel(box);
  const sublocationUnset = box.sublocation.trim() === "";

  return (
    <div className="flex flex-wrap items-center gap-1.5" aria-label="Current location">
      {box.location_id != null && box.location_id > 0 ? (
        <ManufacturingLocationChip
          locationId={box.location_id}
          fallbackLabel={box.location_name ?? undefined}
        />
      ) : (
        <span className={PLACEMENT_CHIP_CLASS}>
          {box.location_name?.trim() || "Unknown site"}
        </span>
      )}
      <span className={PLACEMENT_CHIP_CLASS}>{stationLabel}</span>
      <span
        className={cn(sublocationUnset ? SUBLOCATION_UNSET_CHIP_CLASS : PLACEMENT_CHIP_CLASS)}
      >
        {sublocationLabel}
      </span>
    </div>
  );
}
